import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Chat } from './chat';

@JsonObject('ChatSearchResults')
export class ChatSearchResults extends SearchResults {
    @JsonProperty('results', [Chat])
    results: Chat[] = [];
}